define.alias("shared/components/shared/ui/switcher/action", "media/components/shared/ui/switcher/action");